import { createReducer, on } from '@ngrx/store';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';
import { loadDotCmsHeaderNavigationSuccess } from './dotcms-navigation.action';

export interface DotCmsNavigationState {
  headerNavigation: DotCMSNavigationItem;
}

const initialState: DotCmsNavigationState = { headerNavigation: undefined };

export const dotCmsNavigationReducer = createReducer(
  initialState,
  on(loadDotCmsHeaderNavigationSuccess, (state, action) => ({
    ...state,
    headerNavigation: action.payload.navigationItem,
  }))
);
